import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import store from "../../../../store/createStore";
import { updateFilters } from "../../../services/filters/actions";
import Checkbox from "../../Checkbox";
import "./style.css";

const availableSizes = ["Food"];
try {
	console.log(
		"store.getState() .shopData.data.data.map((x) => x.categoryName)=",
		store.getState().shopData.data
	);
	availableSizes = store
		.getState()
		.shopData.data.data.map((x) => x.categoryName);
	console.log(
		"store.getState() .shopData.data.data.map((x) => x.categoryName)=",
		store.getState().shopData.data
	);
} catch (e) {
	console.log(
		"store.getState() .shopData.data.data.map((x) => x.categoryName) e=",
		e
	);
}

class Filter extends Component {
	constructor(props) {
		super(props);
		this.state = {
			availableFilter: [],
		};
	}
	static propTypes = {
		updateFilters: PropTypes.func.isRequired,
		filters: PropTypes.array,
	};

	componentDidMount() {
		this.setState({
			availableFilter: this.props.shopData.saved
				? this.props.shopData.data.data.map((x) => x.categoryName)
				: [],
		});
		this.selectedCheckboxes = new Set();
	}
	componentDidUpdate(prevProps, prevState, snapshot) {
		if (prevProps.shopData !== this.props.shopData) {
			// Do whatever you want
			console.log(
				"updates happned in this.props.shopData= ",
				this.props.shopData
			);
			this.setState({
				availableFilter: this.props.shopData.saved
					? this.props.shopData.data.data.map((x) => x.categoryName)
					: [],
			});
		}
	}

	toggleCheckbox = (label) => {
		if (this.selectedCheckboxes.has(label)) {
			this.selectedCheckboxes.delete(label);
		} else {
			this.selectedCheckboxes.add(label);
		}

		this.props.updateFilters(Array.from(this.selectedCheckboxes));
	};

	createCheckbox = (label) => (
		<Checkbox
			classes="filters-available-size"
			label={label}
			handleCheckboxChange={this.toggleCheckbox}
			key={label}
		/>
	);

	createCheckboxes = () => this.state.availableFilter.map(this.createCheckbox);

	render() {
		if (!this.props.shopData.saved) {
			return <div> Loading</div>;
		}
		return (
			<div className="filters">
				<h4 className="title">Category:</h4>
				{this.createCheckboxes()}
			</div>
		);
	}
}

const mapStateToProps = (state) => ({
	filters: state.filters.items,
	shopData: state.shopData,
});

export default connect(mapStateToProps, { updateFilters })(Filter);
